// extracted by mini-css-extract-plugin
export default {"row":"TnSmsBalance_row__Uc2ZT","wallet":"TnSmsBalance_wallet__3B8m3","button":"TnSmsBalance_button__Tep7d","number":"TnSmsBalance_number__r1Xgi"};